<div class="btn-container">
  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="viewDetailsAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Detalii</p>
    </button>
  </div>

  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="addNewContractAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt actionCN">Adauga contract nou</p>
    </button>
  </div>
  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="viewExistingContractsAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Vizualizeaza contracte existente</p>
    </button>
  </div>
  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="disassociateConsumptionPlaceAction()"
            [disabled]="!hasUserRights"
    >
      <p class="btn-txt">Dezasociaza loc de consum</p>
    </button>
  </div>
</div>
